import { PatientFormSliceState } from '../slices/patientFormSlice';
import { RootState } from '../store';

export const selectPatientForm = (state: RootState): PatientFormSliceState => state.patientForm;
